import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './HeaderStickyContent.css';

interface IHeaderStickyContentProps {
  title: string;
  published: boolean;
  price?: string;
  phone: React.ReactNode;
}

export const HeaderStickyContent: React.FC<IHeaderStickyContentProps> = ({ title, price, published, phone }) => {
  return (
    <div className={styles['content']}>
      <div className={styles['title']}>{title}</div>
      {price && (
        <div className={clsx(styles['price'], !published && /* istanbul ignore next  */ styles['price--unpublished'])}>
          {price}
        </div>
      )}
      <div className={styles['phone']}>{phone}</div>
    </div>
  );
};
